import React, { ChangeEvent } from "react";
import Card from "../../../runtimeComponent/card";
import { CommentDetail } from "../../../entities/formTemplateDataType";
import CMACommentHeaderComponent from "./CMACommentHeaderComponent";
import { TemplateStatus } from "../../../entities/Constants";

const CMACommentComponent = ({ 
    data, index, newComment, setComment, cmaRole, status, isCommentOwner, deleteComment, readOnly, isEng
}: { 
    data?: CommentDetail,
    index: number,
    isCommentOwner: boolean,
    newComment?: boolean,
    cmaRole: 'A' | 'C', 
    status?: string,
    setComment: (comment: string, index: number, resolved?: boolean) => void,
    deleteComment: (index: number) => void,
    readOnly: boolean,
    isEng: boolean
}) => {

    const handleCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setComment(e.target.value ?? '', -1, cmaRole==='C');
    }

    const footerContent = () => {
        if (cmaRole == 'C' && data.role == 'A' && !data.Resolved) {
            return <button className="ontario-button ontario-button--primary"
            style={{margin: '8px'}}
            onClick={() => setComment(data.Comments, index, true)}>
                {isEng ? "Resolve" : "Résoudre"}
            </button>; 
        }
        if (data.role == 'A' && data.Resolved) {
            return <div className="ontario-badge__container">
                <span className="ontario-badge ontario-badge--neutral-light"
                    style={{backgroundColor: '#FFFFFF', border: '1px solid #000000'}}
                    >{isEng ? "Resolved Comment" : "Commentaire résolu"}</span>
            </div>;
        }

        return null;
    }

    return (
        <>
            {!newComment && (
                <Card className={`notBordered comment-card ${data.role == 'C' ? 'comment-card-champion' : ''}`}
                    header={<CMACommentHeaderComponent 
                        cmaRole={cmaRole}
                        comment={data}
                        index={index}
                        isCommentOwner={isCommentOwner}
                        // handleComentChange={handleCheckboxChange} 
                        deleteComment={deleteComment}
                        status={status}
                        readOnly={readOnly}
                        />}
                    content={<div style={{whiteSpace: 'pre-wrap', padding: '8px', overflowWrap: 'break-word'}}>{data.Comments}</div>}
                    footerContent={footerContent()}
                />
            )}
            {newComment && (cmaRole==='A' || status===TemplateStatus.REVISION) && (
                <textarea 
                    id="new-comment-textarea"
                    placeholder={isEng ? "Start a discussion. Must be resolved prior to approval." : "Lancer une discussion. Doit être résolu avant l’approbation."} 
                    value={data.Comments} onChange={handleCommentChange}
                    rows={5}
                    style={{width: '100%', resize: 'none', padding: '0.5rem'}}
                />
            )}
        </>
    );
}

export default CMACommentComponent;